<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.overview.reminder.title.fullLabel"
                        | translate
                }}
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section>
            <table
                mat-table
                [dataSource]="dataSource"
                matSort matSortActive="code" matSortDirection="asc" matSortDisableClear
                class="tab-content"
                multiTemplateDataRows
            >
                <!-- Code Column -->
                <ng-container matColumnDef="code">
                    <tr>
                        <th
                            class="labelTextHeader"
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            {{
                                "dashboardBizzDev.overview.reminder.table.provider.shortLabel"
                                    | translate
                            }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            class="labelButton"
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.code }}
                        </td>
                    </tr>
                </ng-container>

                <!-- lastImportDate -->
                <ng-container matColumnDef="lastImportDate">
                    <tr>
                        <th
                            class="labelNumberHeader"
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            {{
                                "dashboardBizzDev.overview.reminder.table.date.shortLabel"
                                    | translate
                            }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            class="labelRowNumber"
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.lastImportDate | date: "dd/MM/yyyy" }}
                        </td>
                    </tr>
                </ng-container>
                <!-- Import status Column -->
                <ng-container matColumnDef="importStatus">
                    <tr>
                        <th
                            class="labelNumberHeader"
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            {{
                                "dashboardBizzDev.overview.reminder.table.importStatus.shortLabel"
                                    | translate
                            }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            class="labelRowNumber"
                            mat-cell
                            *matCellDef="let element"
                        >
                            <ng-container
                                *ngIf="
                                    element.code != 'bbc2020' && element.code != 'mjp';
                                    else bbcImport
                                "
                            >
                                <ng-container
                                    *ngIf="
                                        element.daysBetweenDates >= 4;
                                        else sicOK
                                    "
                                >
                                    <p
                                        [ngStyle]="{
                                            color: 'red',
                                            'text-align': 'center'
                                        }"
                                    >
                                        <mat-icon>error</mat-icon>
                                    </p>
                                </ng-container>
                                <ng-template #sicOK>
                                    <p
                                        [ngStyle]="{
                                            color: 'green',
                                            'text-align': 'center'
                                        }"
                                    >
                                        <mat-icon>done</mat-icon>
                                    </p>
                                </ng-template>
                            </ng-container>
                            <ng-template #bbcImport>
                                <ng-container
                                    *ngIf="
                                        element.daysBetweenDates >= 7;
                                        else bbcOK
                                    "
                                >
                                    <p
                                        [ngStyle]="{
                                            color: 'red',
                                            'text-align': 'center'
                                        }"
                                    >
                                        <mat-icon>error</mat-icon>
                                    </p>
                                </ng-container>
                                <ng-template #bbcOK>
                                    <p
                                        [ngStyle]="{
                                            color: 'green',
                                            'text-align': 'center'
                                        }"
                                    >
                                        <mat-icon>done</mat-icon>
                                    </p>
                                </ng-template>
                            </ng-template>
                        </td>
                    </tr>
                </ng-container>

                <!-- Days between dates Column -->
                <ng-container matColumnDef="daysBetweenDates">
                    <tr>
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="labelTextHeader"
                        >
                            {{
                                "dashboardBizzDev.overview.reminder.table.daysBetweenDates.title.shortLabel"
                                    | translate
                            }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            class="labelRowText"
                            mat-cell
                            *matCellDef="let element"
                        >
                            <ng-container
                                *ngIf="element.code != 'bbc2020' && element.code != 'mjp'; else bbcDays"
                            >
                                <ng-container
                                    *ngIf="
                                        element.daysBetweenDates >= 4;
                                        else importIsNotLate
                                    "
                                >
                                    <p>
                                        {{ element.daysBetweenDates
                                        }}{{
                                            "dashboardBizzDev.overview.reminder.table.daysBetweenDates.month.shortLabel"
                                                | translate
                                        }}
                                    </p>
                                </ng-container>
                            </ng-container>
                            <ng-template #bbcDays>
                                <ng-container
                                    *ngIf="
                                        element.daysBetweenDates >= 7;
                                        else importIsNotLate
                                    "
                                >
                                    <p>
                                        {{ element.daysBetweenDates
                                        }}{{
                                            "dashboardBizzDev.overview.reminder.table.daysBetweenDates.day.shortLabel"
                                                | translate
                                        }}
                                    </p>
                                </ng-container>
                            </ng-template>
                            <ng-template #importIsNotLate>
                                <p>
                                    {{
                                        "dashboardBizzDev.overview.reminder.table.noUpdate.shortLabel"
                                            | translate
                                    }}
                                </p>
                            </ng-template>
                        </td>
                    </tr>
                </ng-container>
                <!--Time before next Update Column -->
                <ng-container matColumnDef="timeBeforeNextUpdate">
                    <tr>
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="labelTextHeader"
                        >
                            {{
                                "dashboardBizzDev.overview.reminder.table.timeBeforeNextUpdate.title.fullLabel"
                                    | translate
                            }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            class="labelRowText"
                            mat-cell
                            *matCellDef="let element"
                        >
                            <ng-container
                                *ngIf="
                                    element.code != 'bbc2020' && element.code != 'mjp';
                                    else bbcImport
                                "
                            >
                                <ng-container
                                    *ngIf="
                                        element.daysBetweenDates >= 4;
                                        else sicNextUpdate
                                    "
                                >
                                    <p>
                                        {{
                                            "dashboardBizzDev.overview.reminder.table.timeBeforeNextUpdate.notUpdated.fullLabel"
                                                | translate
                                        }}
                                    </p>
                                </ng-container>
                                <ng-template #sicNextUpdate>
                                    <p>
                                        {{ element.timeBeforeNextUpdate
                                        }}{{
                                            "dashboardBizzDev.overview.reminder.table.daysBetweenDates.day.shortLabel"
                                                | translate
                                        }}
                                    </p>
                                </ng-template>
                            </ng-container>
                            <ng-template #bbcImport>
                                <ng-container
                                    *ngIf="
                                        element.daysBetweenDates >= 7;
                                        else bbcNextUpdate
                                    "
                                >
                                    <p>
                                        {{
                                            "dashboardBizzDev.overview.reminder.table.timeBeforeNextUpdate.notUpdated.fullLabel"
                                                | translate
                                        }}
                                    </p>
                                </ng-container>
                                <ng-template #bbcNextUpdate>
                                    <p>
                                        {{ element.timeBeforeNextUpdate
                                        }}{{
                                            "dashboardBizzDev.overview.reminder.table.daysBetweenDates.day.shortLabel"
                                                | translate
                                        }}
                                    </p>
                                </ng-template>
                            </ng-template>
                        </td>
                    </tr>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let element; columns: displayedColumns"
                ></tr>
            </table>
        </section>
    </mat-card-content>
</mat-card>
